import React from 'react';
import { Page } from 'components';
import Header from "../../components/Header/Header"
import { Form, Card, Row, Col, Button, FloatingLabel, Alert, Spinner } from "react-bootstrap";
import ApiMServer from 'services/ApiMServer';
import phoneMask from 'utils/phoneMask';

const Settings = (props) => {

  const user = JSON.parse(localStorage.getItem('userData'));
  if (user?.permission?.general?.read !== true) {
    window.location.replace('/home');
  }
  
  // Estado do formulário (editável)
  const [formData, setFormData] = React.useState({
    name: user?.name || '',
    fone: user?.fone || '',
    company: user?.company || '',
    country: user?.country || ''
  });

  // Snapshot inicial para detectar alterações e resetar após salvar
  const [initialData, setInitialData] = React.useState({
    name: user?.name || '',
    fone: user?.fone || '',
    company: user?.company || '',
    country: user?.country || ''
  });

  const isDirty =
    formData.name !== initialData.name ||
    formData.fone !== initialData.fone ||
    formData.company !== initialData.company ||
    formData.country !== initialData.country;

  const [saving, setSaving] = React.useState(false);
  const [feedback, setFeedback] = React.useState({ type: '', message: '' });

  // Controle de tema
  const [currentTheme, setCurrentTheme] = React.useState(
    document.body.classList.contains('dark-theme') ? 'dark' : 'light'
  );

  React.useEffect(() => {
    const handleThemeChange = () => {
      setCurrentTheme(document.body.classList.contains('dark-theme') ? 'dark' : 'light');
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          handleThemeChange();
        }
      });
    });

    observer.observe(document.body, { attributes: true });
    return () => observer.disconnect();
  }, []);

  // Estilo para os campos no tema dark (igual NotificationForm)
  const inputStyle = currentTheme === 'dark'
    ? { backgroundColor: '#212529', color: '#fff', '--bs-placeholder-color': '#adb5bd' }
    : {};

  const handleSubmit = (e) => {
    e.preventDefault();
    setFeedback({ type: '', message: '' });

    // Monta apenas campos alterados
    const payload = { _id: user?._id };
    Object.keys(formData).forEach((k) => {
      if (formData[k] !== initialData[k]) payload[k] = formData[k];
    });

    if (Object.keys(payload).length <= 1) {
      setFeedback({ type: 'info', message: 'Nenhuma alteração para salvar.' });
      return;
    }

    setSaving(true);
    ApiMServer.put('/api/v1/user-update', payload)
      .then((res) => {
        // Atualiza localStorage com os novos valores
        try {
          const current = JSON.parse(localStorage.getItem('userData')) || {};
          const updated = { ...current, ...formData };
          localStorage.setItem('userData', JSON.stringify(updated));
        } catch (_) {}

        setInitialData({ ...formData });
        setFeedback({ type: 'success', message: 'Configurações salvas com sucesso.' });
      })
      .catch((err) => {
        console.error(err);
        setFeedback({ type: 'danger', message: 'Falha ao salvar as configurações.' });
      })
      .finally(() => setSaving(false));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let nextValue = value;
    if (name === 'fone') {
      nextValue = phoneMask(value);
    }
    setFormData((prev) => ({ ...prev, [name]: nextValue }));
  };

  return (
    <Page className="p-3" title="Configuração">

      <Header page={"Configuração"} />

      <Card
        className={`mb-3 mt-2 p-3 ${currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}`}
      >
        {feedback.message && (
          <Alert
            variant={feedback.type === 'danger' ? 'danger' : feedback.type || (currentTheme === 'dark' ? 'secondary' : 'info')}
            className="mb-3"
          >
            {feedback.message}
          </Alert>
        )}
        <Row className="g-2">
          <Col md>
            <FloatingLabel controlId="floatingInput" label="Nome" className="mb-3">
              <Form.Control
                className="border-success"
                type="text"
                name="name"
                placeholder="Nome"
                value={formData.name}
                onChange={handleChange}
                style={inputStyle}
              />
            </FloatingLabel>
          </Col>
          <Col md>
            <FloatingLabel controlId="floatingInput" label="E-mail" className="mb-3">
              <Form.Control
                className="border-success"
                type="email"
                name="E-mail"
                placeholder="E-mail"
                value={user?.email || ''}
                disabled
                style={inputStyle}
              />
            </FloatingLabel>
          </Col>
          <Col md>
            <FloatingLabel controlId="floatingInput" label="Telefone" className="mb-3">
              <Form.Control
                className="border-success"
                type="text"
                name="fone"
                placeholder="Telefone"
                value={formData.fone}
                onChange={handleChange}
                style={inputStyle}
              />
            </FloatingLabel>
          </Col>
        </Row>

        <Row className="g-2">
          <Col md>
            <FloatingLabel controlId="floatingInput" label="CPF" className="mb-3">
              <Form.Control
                className="border-success"
                type="text"
                name="cpf"
                placeholder="CPF"
                value={user?.cpfcnpj || ''}
                disabled
                style={inputStyle}
              />
            </FloatingLabel>
          </Col>
          <Col md>
            <FloatingLabel controlId="floatingCompany" label="Empresa" className="mb-3">
              <Form.Control
                className="border-success"
                type="text"
                name="company"
                placeholder="Empresa"
                value={formData.company}
                onChange={handleChange}
                style={inputStyle}
              />
            </FloatingLabel>
          </Col>
          <Col md>
            <FloatingLabel controlId="floatingInput" label="País" className="mb-3">
              <Form.Control
                className="border-success"
                type="text"
                name="country"
                placeholder="País"
                value={formData.country}
                onChange={handleChange}
                style={inputStyle}
                disabled
              />
            </FloatingLabel>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button
              variant="success"
              type="submit"
              onClick={handleSubmit}
              disabled={!isDirty || saving}
            >
              {saving ? (
                <><Spinner as="span" animation="border" size="sm" className="me-2" /> Salvando...</>
              ) : (
                'Salvar'
              )}
            </Button>
          </Col>
        </Row>
      </Card>
    </Page>
  );
};

export default Settings;
